module.exports = __webpack_public_path__ + "static/media/banner.5ab22fd9.png";